import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { EndpointKey } from '../http/EndpointKey';
import { useRetryEndpoint } from '../http/useRetryEndpoint';
import imageUrls from '../images/imageUrls';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const RateLimitedCreationError = () => {
  const dispatch = useDispatch();
  const {
    retryEndpoint,
    isLoading,
    handleLoadingOnRetry
  } = useRetryEndpoint();

  const onClick = event => {
    event.preventDefault();
    handleLoadingOnRetry(); // Adding a timeout for better chances of success in case of server unreliability

    dispatch(retryEndpoint(EndpointKey.Signup, 2200));
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.RateLimitedError,
    imageURL: imageUrls.clock,
    isButtonLoading: isLoading,
    linkToHelpResources: true,
    onSentenceWithLinkClick: onClick
  });
};

export default RateLimitedCreationError;